import { render, staticRenderFns } from "./ReservationPaymentConfirm.vue?vue&type=template&id=3578fd9e"
import script from "./ReservationPaymentConfirm.vue?vue&type=script&lang=js"
export * from "./ReservationPaymentConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports